// import type { LiveChat } from 'src/types/live'
// import { v4 as uuid } from 'uuid'
import type { StateCreator } from 'zustand'
import type { LiveBubbleMessage, LiveChat } from '../../types/lives/live'

interface State {
  chat: LiveChat[]
  bubbleMessages: LiveBubbleMessage[]
}

interface Actions {
  addMessageChatLive: (liveChat: LiveChat) => void
  clearChatLive: () => void
  clearNotificationsChatLive: () => void

  addBubbleMessageLive: (bubbleMessage: LiveBubbleMessage) => void
  removeBubbleMessageLive: (bubbleMessageId: string) => void
  clearBubbleMessage: () => void
}

export type ChatLiveSlice = State & Actions

export const chatLiveStore: StateCreator<
  ChatLiveSlice,
  [],
  [],
  ChatLiveSlice
> = (set) => ({
  chat: [],
  bubbleMessages: [],
  addMessageChatLive: (liveChat) => {
    set((prevState) => ({
      chat: prevState?.chat?.concat(liveChat),
    }))
  },
  clearChatLive: () => {
    set((prevState) => ({ chat: prevState.chat.slice(90, 100) }))
  },
  clearNotificationsChatLive: () => {
    set((prevState) => ({
      chat: prevState?.chat?.filter((message) => typeof message !== 'string'),
    }))
  },
  addBubbleMessageLive: (bubbleMessage) => {
    set((prevState) => ({
      bubbleMessages: prevState?.bubbleMessages?.concat({
        ...bubbleMessage,
        id: String(Date.now()),
      }),
    }))
  },
  removeBubbleMessageLive: (bubbleMessageId) => {
    set((prevState) => ({
      bubbleMessages: prevState?.bubbleMessages?.filter(
        (bubbleMessage) => bubbleMessage?.id !== bubbleMessageId,
      ),
    }))
  },
  clearBubbleMessage: () => {
    set({ chat: [] })
  },
})
